import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Mustafa Raslan | Web Developer', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hello, my name is',
  name: 'Mustafa',
  subtitle: 'I like to make stuff with code',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'resume.png',
  paragraphOne:
    'I am a Web Developer with enthusiasm and focus on Frontend Development and Scripting.',
  paragraphTwo:
    'I am passionate about building scalable software, creating effective solutions, and learning every day to grow professionally in the IT field.',
  paragraphThree: 'Feel free to contact me via email at any time',
  resume: 'https://drive.google.com/file/d/1a-Hsh4EhS9Kznm-DaJ_G3J0AK2ERKYsA/view?usp=sharing', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'netflix.png',
    title: 'NETFLIX app',
    info: `Building Netflix from Scratch Using React (Custom Hooks, Context, Portals), Firebase, Compound & Styled Components`,
    info2:
      ' There are four different pages, some using protected routes with auth listeners. The styling is all handled via styled components. Using compound components made my actual dumb components really easy to test.',
    url: 'https://netflix-m.netlify.app/',
    repo: 'https://github.com/Mostafa-Ragab/netflix', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'fashion-clothing.png',
    title: 'Fashion Clothing App',
    info:
      'A massive e-commerce clothing shopping app built with React/Redux, React-Hooks, React-Suspense, React-Router, GraphQL, Context API, Redux-Saga, Stripe , and Firebase(For User Registration & Authentication and Data Persistence).',
    info2:
      ' A simple Express backend server to handle Stripe payment. Refactored the app into a PWA.',
    url: 'https://fashion-crown.herokuapp.com/',
    repo: 'https://github.com/Mostafa-Ragab/-Fashion-clothing', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'facebook.png',
    title: 'Facebook Clone',
    info: `The objective of this project is to build a minimal responsive facebook clone version come with the following features:`,
    info2:
      'Register new account. User authentication with Google account.Writing posts and comments(text & image).Notifications for new friend request.Sending/accepting/cancel friend requests.',
    url: 'https://facebook-clone-a367a.web.app/',
    repo: 'https://github.com/Mostafa-Ragab/facebook-clone', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'profile.png',
    title: 'my portfolio',
    info: `A clean, beautiful and responsive portfolio template.`,
    info2:
      ' This project was highlighted in one of the highest valorated courses on Udemy, called Zero To Mastery.',
    url: 'https://mustafa-raslan.netlify.app/',
    repo: 'https://github.com/Mostafa-Ragab/My-React-Portfolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'face.png',
    title: 'Face Recognition App',
    info: `A full-stack web application using the (MERN) Stack, this app allows you to identify the detection of faces in any image supplied. This was achieved thanks to Clarifai's artificial intelligence API.`,
    info2: 'I used React, Node, Express.js and MongoDB in order to create this web application.',
    url: 'https://mostafa-ragab.github.io/Face-recognitionapp/',
    repo: 'https://github.com/Mostafa-Ragab/Face-recognitionapp', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'quote.png',
    title: 'Quote Generator',
    info: 'VanillaJS: Using an API to build a random quote generator with Twitter integration.',
    info2: '',
    url: 'https://mostafa-ragab.github.io/samrt-quote-generator/',
    repo: 'https://github.com/Mostafa-Ragab/samrt-quote-generator', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'monster.png',
    title: 'Monstor Rolodex',
    info: 'monster React App build which focused on using an API, state, and component lifecycles.',
    info2: 'Built with React, Tachyons, Cufon Fonts, Robohash, and JSON Placeholder API.',
    url: 'https://mostafa-ragab.github.io/monstor-rolodex/',
    repo: 'https://github.com/Mostafa-Ragab/monstor-rolodex', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'joke teller.png',
    title: 'Joke Teller ',
    info: 'an app that combines a Joke API, and a speech-to-text AP to say jokes.',
    info2: '',
    url: 'https://mostafa-ragab.github.io/joke-teller/',
    repo: 'https://github.com/Mostafa-Ragab/joke-teller', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: `Let's build together!`,
  email: 'mostafaragab373@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'facebook.com/mostafa.rslan.9406/',
    },
    {
      id: nanoid(),
      name: 'codepen',
      url: '',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/mostafa-raslan/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Mostafa-Ragab',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
